import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { EncounterRowData } from "./encounter-rows";

export type EncounterTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function EncounterTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Encounters",
  isRowViewed,
}: EncounterTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  const columns: ColumnDef<EncounterRowData>[] = useMemo(
    () => [
      { key: "reasons", header: "Reasons", maxWidth: "300px" },
      { key: "type", header: "Type", maxWidth: "300px", hideOnSmallScreen: true },
      { key: "location", header: "Location", hideOnSmallScreen: true },
      {
        key: "startDate",
        header: "Start Date",
        sort: "desc",
        width: "120px",
      },
      {
        key: "endDate",
        header: "End Date",
        width: "120px",
        hideOnSmallScreen: true,
      },
    ],
    []
  );

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as EncounterRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
